export const ACTIVATION_ALERTS_ROOT_ROUTE = "sw.activation-alerts-root";
export const ACTIVATION_ALERTS_ROUTE = `${ACTIVATION_ALERTS_ROOT_ROUTE}.activation-alerts`;
